module.exports = __webpack_public_path__ + "img/bnr2021-3.ceb6e632.jpg";